import { render, staticRenderFns } from "./MembersOnly.vue?vue&type=template&id=36160725&"
import script from "./MembersOnly.vue?vue&type=script&lang=ts&"
export * from "./MembersOnly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports